/*=====================================
    開立發票資訊

    Author: Gray
    createtime: 2018 / 01 / 11
=====================================*/

/*--------------------------
    Import
--------------------------*/
import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import actionCreators from 'actions/creators';
import GLOBAL from 'jcolorglobal';
import download from 'downloadjs';
import classNames from "classnames";
import TimeFormat from 'components/commons/TimeFormat';
import CupoyRouter from "components/commons/router/CupoyRouter";
import CupoySrefView from "components/commons/router/CupoySrefView";

/*--------------------------
    Icon
--------------------------*/
class InvoiceInfoView extends Component {

    constructor(props) {
        super(props);

        this.state = {
            yearmonth: '',
            istarttag: '',
            invoicenumber: '',
            isLoading: false,
            isError: false,
            fromState: undefined,
            showReuploadButton: false,
        };

        this.showReuploadButton1Count = 0;
        this.showReuploadButton2Count = 0;

        this.dnldInvoice = this.dnldInvoice.bind(this);
        this.failInvoice = this.failInvoice.bind(this);
        this.setInvoiceSent = this.setInvoiceSent.bind(this);
        this.reUploadInvoicePdf = this.reUploadInvoicePdf.bind(this);
        // 顯示更新雲端發票按鈕的入口
        this.showReuploadButton1 = this.showReuploadButton1.bind(this);
        this.showReuploadButton2 = this.showReuploadButton2.bind(this);
    }

    componentDidMount() {

        var stateHistory = CupoyRouter.getHistory();
        var fromState;

        if(stateHistory.length > 1) {
            var prev = stateHistory[stateHistory.length - 2],
                statename;

            if(prev) {
                statename = prev.state.name;

                if(statename === CupoyRouter.STATES.INVOICE_LIST) {
                    fromState = prev;
                }
            }
        }

        this.setState({
            fromState: fromState,
        });

        this.init(this.props);
    }

    componentWillReceiveProps(nextProps) {

        this.init(nextProps);
    }

    init(props) {

        if (!props.match) {
            return;
        }

        const {
            yearmonth,
            istarttag,
            invoicenumber,
        } = props.match.params;

        if(yearmonth === this.state.yearmonth && istarttag === this.state.istarttag && invoicenumber === this.state.invoicenumber) {
            return;
        }

        this.setState({
            yearmonth: yearmonth,
            istarttag: istarttag,
            invoicenumber: invoicenumber,
            isLoading: true,
            isError: false,
        }, () => {
            // get invoice from redux
            const invoice = props.invoices[istarttag + invoicenumber];

            if (!invoice) {
                // 沒經過list就進來，抓取發票資料
                this.props.invoiceActions.getInvoiceInfo({
                    yearmonth: yearmonth,
                    istarttag: istarttag,
                    invoicenumber: invoicenumber,
                }).then((result) => {
                    this.setState({
                        isLoading: false,
                    });
                }, (error) => {
                    this.setState({
                        isLoading: false,
                        isError: true,
                    });
                });
            } else {
                this.setState({
                    isLoading: false,
                });
            }
        })
    }

    // ------------------------------
    // 下載發票
    // ------------------------------
    dnldInvoice(invoice){

        const x = new XMLHttpRequest();
        x.open( "GET", '/InvoiceAction.do?op=dnldInvoice&yearmonth='+
            invoice.yearmonth+'&istarttag='+invoice.istarttag+'&invoiceNumber='+
            invoice.invoicenumber + '&invoiceType='+invoice.invoicetype , true);
        x.responseType="blob";
        x.onload = function(e){download(e.target.response,
            invoice.istarttag+'-'+invoice.invoicenumber+'.xls',
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
        };
        x.send();
    }

    // ------------------------------
    // 作廢發票
    // ------------------------------
    failInvoice(invoice) {

        this.props.webActions.openConfirmDialog({
            title: '確定作廢發票'+invoice.istarttag+invoice.invoicenumber+'？',
            confirmCallback: () => {
                this.props.invoiceActions.failInvoice(invoice)
            },
        });
    }

    // ------------------------------
    // 設為已寄送
    // ------------------------------
    setInvoiceSent(invoice) {

        this.props.webActions.openConfirmDialog({
            title: '確定將發票'+invoice.istarttag+invoice.invoicenumber+'設為已寄送？',
            confirmCallback: () => {
                this.props.invoiceActions.updateInvoiceStatus({
                    yearmonth: invoice.yearmonth,
                    istarttag: invoice.istarttag,
                    invoiceNumber: invoice.invoicenumber,
                    istatus: 4,
                })
            },
        });
    }

    getSettletypeText(settletype) {

        switch(Number(settletype)){
            case GLOBAL.SETTLE_TYPE.SYSTEM: return '系統自動開立';
            case GLOBAL.SETTLE_TYPE.OPERATOR: return '手動開立';
            default: return '-';
        }
    }

    getStatusText(status){

        switch(Number(status)){
            case 1: return '捐贈';
            case 2: return '未寄出';
            case 3: return '中獎未寄出';
            case 4: return '已寄出';
            default: return '';
        }
    }

    getFailStatusText(status){

        switch(Number(status)){
            case 0: return '開立';
            case 1: return '作廢';
            case 2: return '折讓';
            default: return '開立';
        }
    }

    getOptionText(option){

        switch(Number(option)){
            case 1: return '寄送';
            case 2: return '捐贈';
            case 3: return '載具';
            default: return '捐贈';
        }
    }

    getCarrierTypeText(carrierType) {

        switch(carrierType) {
            case GLOBAL.CARRIER_TYPE.MEMBER.value:
                return GLOBAL.CARRIER_TYPE.MEMBER.label;
            case GLOBAL.CARRIER_TYPE.CITIZEN_CERT.value:
                return GLOBAL.CARRIER_TYPE.CITIZEN_CERT.label;
            case GLOBAL.CARRIER_TYPE.MOBILE.value:
                return GLOBAL.CARRIER_TYPE.MOBILE.label;
            default:
                return '-';
        }
    }

    reUploadInvoicePdf(invoice) {

        this.props.webActions.openConfirmDialog({
            title: '確定重新產生客戶雲端發票'+invoice.istarttag+invoice.invoicenumber+'檔案？',
            isPromise: true,
            confirmPromise: () => {
                const promise = new Promise((resolve, reject) => {
                    this.props.invoiceActions.reUploadInvoicePdf({
                        yearmonth: invoice.yearmonth,
                        istarttag: invoice.istarttag,
                        invoicenumber: invoice.invoicenumber,
                    }).then((result) => {
                        if (result) {
                            resolve(true);
                        } else {
                            reject('發生無法處理的錯誤，請聯絡工程師');
                        }
                    }, (error) => {
                        if (error && error.message) {
                            reject(error.message);
                        } else {
                            reject('發生無法處理的錯誤，請聯絡工程師');
                        }
                    });
                });
                return promise;
            },
        });
    }

    showReuploadButton1() {

        const {
            showReuploadButton,
        } = this.state;

        this.showReuploadButton1Count++;

        if(!showReuploadButton && this.showReuploadButton1Count > 10 && this.showReuploadButton2Count > 10) {
            this.setState({
                showReuploadButton: true,
            })
        }
    }

    showReuploadButton2() {

        const {
            showReuploadButton,
        } = this.state;

        this.showReuploadButton2Count++;

        if(!showReuploadButton && this.showReuploadButton1Count > 10 && this.showReuploadButton2Count > 10) {
            this.setState({
                showReuploadButton: true,
            })
        }
    }

    renderButtonGroup(invoice) {

        if(!invoice) {
            return null;
        }

        const {
            yearmonth,
            istarttag,
            invoicenumber,
            showReuploadButton,
        } = this.state;

        const detail = invoice.detail;

        var ifailstatus;
        var istatus;

        if(detail) {
            ifailstatus = Number(detail.ifailstatus);
            istatus = Number(detail.istatus);
        }

        return (
            <div className="button-group">
                {showReuploadButton ?
                    <a className="button gray" onClick={() => this.reUploadInvoicePdf(invoice)}>
                        更新雲端發票
                    </a>
                    :
                    null
                }
                <a className="button green" onClick={() => this.dnldInvoice(invoice)}>
                    下載
                </a>
                {invoice.turnkeyupcasttime === -1 ?
                    <CupoySrefView
                        className="button blue"
                        statename={CupoyRouter.STATES.EDIT_INVOICE}
                        params={{
                            yearmonth: yearmonth,
                            istarttag: istarttag,
                            invoicenumber: invoicenumber,
                        }}
                    >
                        編輯
                    </CupoySrefView>
                    :
                    null
                }
                {!ifailstatus || ifailstatus === 0 ?
                    <CupoySrefView
                        className="button blue"
                        statename={CupoyRouter.STATES.CREATE_ALLOWANCE}
                        params={{
                            yearmonth: yearmonth,
                            istarttag: istarttag,
                            invoicenumber: invoicenumber,
                        }}
                    >
                        折讓
                    </CupoySrefView>
                    :
                    null
                }
                {ifailstatus === 2 ?
                    <CupoySrefView
                        className="button orange"
                        statename={CupoyRouter.STATES.ALLOWANCE_INFO}
                        params={{
                            allowancenumber: `${istarttag}${invoicenumber}`,
                        }}
                    >
                        查看折讓資訊
                    </CupoySrefView>
                    :
                    null
                }

                {istatus === 2 || istatus === 3 ?
                    <a className="button blue" onClick={() => this.setInvoiceSent(invoice)}>
                        設為已寄出
                    </a>
                    :
                    null
                }
                {!ifailstatus || ifailstatus === 0 ?
                    <a className="button red" onClick={() => this.failInvoice(invoice)}>
                        作廢
                    </a>
                    :
                    null
                }
            </div>
        );
    }

    renderInvoice(invoice) {

        if(!invoice) {
            return (
                <div className="form has-padding">
                    <div className="form-row">
                        <div className="form-col loading">
                            找不到該發票。
                        </div>
                    </div>
                </div>
            );
        }

        const {
            yearmonth,
            istarttag,
            invoicenumber,
        } = this.state;

        const {
            orderid,
            mrscid,
            detail,
            receipttime,
            canceltime,
            // turnkeycancelupcasttime,
        } = invoice;

        const isTriCopy = detail.buyerinfo && detail.buyerinfo.buyercrn && detail.buyerinfo.buyercrn !== GLOBAL.DEFAULT_BUYERCRN;

        var salesamount = detail.salesamount;
        var salestax = detail.salestax;

        // 二聯式發票因為 detail.salesamount 為含稅價，salestax 為 0，但列表還是要呈現未稅含稅價，因此直接除1.05
        if(!isTriCopy) {
            salesamount = Math.round(salesamount / 1.05);
            // 驗證是否正確
            var check = Math.round(salesamount * 1.05) - detail.salesamount;
            if(check > 0) {
                salesamount -= 1;
            } else if(check < 0) {
                salesamount += 1;
            }

            salestax = detail.salesamount - salesamount;
        }

        return (
            <div className="scroll-content">
                <div className="form">
                    <div className="block-form">
                        <h3 className="block-title">發票資訊
                            <a className="label-link" onClick={() => this.reUploadInvoicePdf(invoice)}>
                                （重新產生發票pdf）
                            </a>
                        </h3>
                        <div className="block-form-row">
                            <label className="block-form-col">
                                <h5 className="title">期別</h5>
                                <div className="description">
                                    {yearmonth}
                                </div>
                            </label>
                            <label className="block-form-col">
                                <h5 className="title">發票號碼</h5>
                                <div className="description">
                                    {istarttag}-{invoicenumber}
                                </div>
                            </label>
                        </div>
                        <div className="block-form-row">
                            <label className="block-form-col">
                                <h5 className="title">開立時間</h5>
                                <div className="description">
                                    {receipttime > 0 ?
                                        <TimeFormat
                                            format="simpleFullTime"
                                            time={receipttime}
                                        />
                                        :
                                        null
                                    }
                                </div>
                            </label>
                            <label className="block-form-col">
                                <h5 className="title">開立方式</h5>
                                <div className="description">
                                    {this.getSettletypeText(detail.settletype)}
                                </div>
                            </label>
                        </div>
                        <div className="block-form-row">
                            <label className="block-form-col">
                                <h5 className="title">發票狀態</h5>
                                <div className="description">
                                    {this.getFailStatusText(detail.ifailstatus)}－{this.getStatusText(detail.istatus)}
                                </div>
                            </label>
                            <label className="block-form-col">
                                <h5 className="title">銷售額</h5>
                                <div className="description">
                                    {salesamount}
                                </div>
                            </label>
                        </div>
                        <div className="block-form-row">
                            <label className="block-form-col">
                                <h5 className="title">營業稅</h5>
                                <div className="description">
                                    {salestax}
                                </div>
                            </label>
                            <label className="block-form-col">
                                <h5 className="title">含稅總額</h5>
                                <div className="description">
                                    {salesamount + salestax}
                                </div>
                            </label>
                        </div>
                        <div className="block-form-row">
                            <label className="block-form-col">
                                <h5 className="title">訂單編號</h5>
                                <div className="description">
                                    {orderid}
                                </div>
                            </label>
                            <label className="block-form-col">
                                <h5 className="title">會員編號</h5>
                                <div className="description">
                                    {mrscid}
                                </div>
                            </label>
                        </div>

                        {canceltime > 0 ?
                            <div className="block-form-row">
                                <label className="block-form-col">
                                    <h5 className="title">作廢時間</h5>
                                    <div className="description">
                                        {canceltime > 0 ?
                                            <TimeFormat
                                                format="simpleFullTime"
                                                time={canceltime}
                                            />
                                            :
                                            null
                                        }
                                    </div>
                                </label>
                                <label className="block-form-col">
                                    {/* <h5 className="title">作廢上傳時間</h5>
                                    <div className="description">
                                        {turnkeycancelupcasttime > 0 ?
                                            <TimeFormat
                                                format="simpleFullTime"
                                                time={turnkeycancelupcasttime}
                                            />
                                            :
                                            null
                                        }
                                    </div> */}
                                </label>
                            </div>
                            :
                            null
                        }
                    </div>

                    <div className="block-form">
                        <h3 className="block-title" onClick={this.showReuploadButton1}>買受人資訊</h3>
                        <div className="block-form-row">
                            <label
                                className={classNames("block-select-col", {
                                   'blue': !isTriCopy
                                })}
                            >
                                <i className="zmdi zmdi-check"></i>
                                二聯式發票
                            </label>
                            <label
                                className={classNames("block-select-col", {
                                   'blue': isTriCopy
                                })}
                            >
                                <i className="zmdi zmdi-check"></i>
                                三聯式發票
                            </label>
                        </div>

                        <div className="block-form-row">
                            <label className="block-form-col">
                                <h5 className="title">買受人</h5>
                                <div className="description">
                                    {detail.buyerinfo.buyername}
                                </div>
                            </label>
                            <label className="block-form-col">
                                <h5 className="title">買受人EMail</h5>
                                <div className="description">
                                    {detail.email}
                                </div>
                            </label>
                        </div>

                        {isTriCopy ?
                            <div>
                                <div className="block-form-row">
                                    <label className="block-form-col">
                                        <h5 className="title">買受人統編</h5>
                                        <div className="description">
                                            {detail.buyerinfo.buyercrn}
                                        </div>
                                    </label>
                                    <label className="block-form-col">
                                        <h5 className="title">買受人地址</h5>
                                        <div className="description">
                                            {detail.buyerinfo.buyeraddress}
                                        </div>
                                    </label>
                                </div>
                                <div className="block-form-row">
                                    <label className="block-form-col">
                                        <h5 className="title">買受人電話</h5>
                                        <div className="description">
                                            {detail.buyerinfo.buyertel}
                                        </div>
                                    </label>
                                    <label className="block-form-col">
                                        <h5 className="title">發票寄送地址</h5>
                                        <div className="description">
                                            {detail.address}
                                        </div>
                                    </label>
                                </div>
                                <div className="block-form-row">
                                    <label className="block-form-col">
                                        <h5 className="title">發票寄送時間</h5>
                                        <div className="description">
                                            {detail.sendtime > 0 ?
                                                <TimeFormat
                                                    format="simpleTime"
                                                    time={detail.sendtime}
                                                />
                                                :
                                                null
                                            }
                                        </div>
                                    </label>
                                    <label className="block-form-col"></label>
                                </div>
                            </div>
                            :
                            <div>
                                <div className="block-form-row">
                                    <label className="block-form-col">
                                        <h5 className="title">發票寄送地址</h5>
                                        <div className="description">
                                            {detail.address}
                                        </div>
                                    </label>
                                    <label className="block-form-col">
                                        <h5 className="title">發票寄送時間</h5>
                                        <div className="description">
                                            {detail.sendtime > 0 ?
                                                <TimeFormat
                                                    format="simpleTime"
                                                    time={detail.sendtime}
                                                />
                                                :
                                                null
                                            }
                                        </div>
                                    </label>
                                </div>
                            </div>
                        }
                    </div>

                    <div className="block-form">
                        <h3 className="block-title" onClick={this.showReuploadButton2}>捐贈資訊</h3>
                        <div className="block-form-row">
                            <label className="block-form-col">
                                <h5 className="title">捐贈類型</h5>
                                <div className="description">
                                    {this.getOptionText(detail.option)}
                                </div>
                            </label>
                            <label className="block-form-col">
                                <h5 className="title">捐贈愛心碼</h5>
                                <div className="description">
                                    {detail.loveCode ? detail.loveCode : '-'}
                                </div>
                            </label>
                        </div>
                        <div className="block-form-row">
                            <label className="block-form-col">
                                <h5 className="title">載具類別</h5>
                                <div className="description">
                                    {this.getCarrierTypeText(detail.carrierType)}
                                </div>
                            </label>
                            <label className="block-form-col">
                                <h5 className="title">載具代碼</h5>
                                <div className="description">
                                    {detail.carrierId1 && detail.carrierId2 ?
                                        <span>明碼：{detail.carrierId1}，隱碼：{detail.carrierId2}</span>
                                        :
                                        '-'
                                    }
                                </div>
                            </label>
                        </div>
                    </div>

                    {Array.isArray(detail.pdtlist) && detail.pdtlist.length > 0 ?
                        <div className="block-form">
                            <h3 className="block-title">商品資訊</h3>

                            {detail.pdtlist.map((product, index) => {
                                return (
                                    <div className="block-form-row" key={index}>
                                        <label className="block-form-col">
                                            <h5 className="title">商品名稱</h5>
                                            <div className="description">
                                                {product.pdtname}
                                            </div>
                                        </label>
                                        <label className="block-form-col">
                                            <h5 className="title">商品編號</h5>
                                            <div className="description">
                                                {product.pdtid}
                                            </div>
                                        </label>
                                        <label className="block-form-col">
                                            <h5 className="title">商品數量</h5>
                                            <div className="description">
                                                {product.pdtcount}
                                            </div>
                                        </label>
                                        <label className="block-form-col">
                                            <h5 className="title">商品單價(未稅)</h5>
                                            <div className="description">
                                                {product.pdtprice}
                                            </div>
                                        </label>
                                    </div>
                                );
                            })}
                        </div>
                        :
                        null
                    }
                </div>
            </div>
        )
    }

    render() {

        const {
            istarttag,
            invoicenumber,
            isLoading,
            isError,
            fromState,
        } = this.state;

        const invoice = this.props.invoices[istarttag + invoicenumber];

        return (
            <div id="invoice-info">
                <div className="header-bar mix">
                    <ul className="bread-crumbs">
                        <li className="crumb-item">
                            {fromState ?
                                <CupoySrefView
                                    statename={fromState.state.name}
                                    params={fromState.params}
                                    querys={fromState.querys}
                                >
                                    開立發票列表
                                </CupoySrefView>
                                :
                                <CupoySrefView
                                    statename={CupoyRouter.STATES.INVOICE_LIST}
                                    params={{
                                        page: 1,
                                    }}
                                >
                                    開立發票列表
                                </CupoySrefView>
                            }
                        </li>
                        <div className="crumb-arrow"><i className="zmdi zmdi-chevron-right"></i></div>
                        <li className="crumb-item active">
                            <a>發票「{istarttag}-{invoicenumber}」</a>
                        </li>
                    </ul>

                    {this.renderButtonGroup(invoice)}
                </div>

                {isLoading ?
                    <div className="form has-padding">
                        <div className="form-row">
                            <div className="form-col loading">
                                <i className="zmdi zmdi-spinner animate-spinner"></i>
                                <span>正在讀取訂單資訊</span>
                            </div>
                        </div>
                    </div>
                    :
                    null
                }

                {isError ?
                    <div className="form has-padding">
                        <div className="form-row">
                            <div className="form-col loading">
                                發生錯誤，請再嘗試一次。
                            </div>
                        </div>
                    </div>
                    :
                    null
                }

                {!isLoading && !isError ?
                    this.renderInvoice(invoice)
                    :
                    null
                }
            </div>
        );
    }
}

const mapStateToProps = function (state) {
    return {invoices: state.invoice.invoices};
};

const mapActionToProps = function (dispatch) {
    return {
        invoiceActions: bindActionCreators(actionCreators.invoiceActionCreators, dispatch),
        webActions: bindActionCreators(actionCreators.webActionCreators, dispatch)
    };
};

export default connect(mapStateToProps, mapActionToProps, null, {withRef: true})(InvoiceInfoView);



// WEBPACK FOOTER //
// ./src/components/invoice/InvoiceInfoView.jsx